import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "gridButton", "listButton"]
  static values = {
    view: { type: String, default: "grid" }
  }

  connect() {
    this.element.dataset.productViewInitialized = "true"
    // Load view preference from cookie
    const savedView = this.getCookie("shop_product_view")
    if (savedView) {
      this.viewValue = savedView
    }
    this.applyView()
  }

  switchToGrid(event) {
    event.preventDefault()
    this.viewValue = "grid"
    this.saveToCookie("grid")
    this.applyView()
  }

  switchToList(event) {
    event.preventDefault()
    this.viewValue = "list"
    this.saveToCookie("list")
    this.applyView()
  }

  applyView() {
    if (this.viewValue === "grid") {
      // Grid view: 4 columns on xl, 3 on lg, 2 on md, 1 on mobile
      this.containerTarget.className = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
      this.gridButtonTarget.classList.add("bg-slate-700", "text-white")
      this.gridButtonTarget.classList.remove("bg-white", "text-slate-700", "hover:bg-slate-50")
      this.listButtonTarget.classList.remove("bg-slate-700", "text-white")
      this.listButtonTarget.classList.add("bg-white", "text-slate-700", "hover:bg-slate-50")
    } else {
      // List view: single column
      this.containerTarget.className = "grid grid-cols-1 gap-4"
      this.listButtonTarget.classList.add("bg-slate-700", "text-white")
      this.listButtonTarget.classList.remove("bg-white", "text-slate-700", "hover:bg-slate-50")
      this.gridButtonTarget.classList.remove("bg-slate-700", "text-white")
      this.gridButtonTarget.classList.add("bg-white", "text-slate-700", "hover:bg-slate-50")
    }

    // Update product card layouts
    const productCards = this.containerTarget.querySelectorAll('.product-card')
    productCards.forEach(card => {
      if (this.viewValue === "list") {
        // List view: horizontal layout
        card.classList.add("flex-row")
        card.classList.remove("flex-col")

        const image = card.querySelector('.product-image')
        if (image) {
          image.classList.remove("h-48")
          image.classList.add("w-48", "h-full")
        }
      } else {
        // Grid view: vertical layout
        card.classList.remove("flex-row")
        card.classList.add("flex-col")

        const image = card.querySelector('.product-image')
        if (image) {
          image.classList.add("h-48")
          image.classList.remove("w-48", "h-full")
        }
      }
    })
  }

  saveToCookie(view) {
    // Save for 1 year
    const date = new Date()
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000))
    document.cookie = `shop_product_view=${view};expires=${date.toUTCString()};path=/;SameSite=Lax`
  }

  getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
      return parts.pop().split(';').shift()
    }
    return null
  }
}
